/**
 * ref attribution writer (H-140 action pipeline).
 *
 * Mirrors the storefront mms-share-ref.liquid contract exactly — same cookie
 * name, value shape, and validation — so a token carried into the hub URL
 * (?ref=gallery|gallery_design|products|create) or produced by an in-page
 * entry action (products card click, Create "use this design" exit) lands in
 * the same mms_ref cookie a storefront share link would set.
 */

const REF_TOKEN_PATTERN = /^[A-Za-z0-9_-]+$/
const REF_TOKEN_MAX_LENGTH = 128
const REF_COOKIE_MAX_AGE = 2592000 // 30 days, mirrors mms-share-ref.liquid

/**
 * Persist the attribution token as `mms_ref=<token>.<ts>`.
 * @param {string} token - ref token (gallery / gallery_design / products / create)
 * @returns {boolean} true when the cookie write was attempted with a valid token
 */
export function writeRefAttribution(token) {
  if (
    typeof token !== 'string' ||
    token.length === 0 ||
    token.length > REF_TOKEN_MAX_LENGTH ||
    !REF_TOKEN_PATTERN.test(token)
  ) {
    return false
  }
  try {
    document.cookie = `mms_ref=${encodeURIComponent(token)}.${Date.now()}; Max-Age=${REF_COOKIE_MAX_AGE}; Path=/; SameSite=Lax`
    return true
  } catch {
    return false // non-DOM context (tests without jsdom cookie jar) — attribution is best-effort
  }
}

export default writeRefAttribution
